import { Component } from '@angular/core';

@Component({
    selector: 'yellow-crayon-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/yellowcrayon.svg',
    styleUrls: ['../svg.component.scss']
})
export class YellowCrayonCharacter {

}